// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__rp2t5"};